import { render, staticRenderFns } from "./backup-restore.component.vue?vue&type=template&id=1949b91a"
import script from "./backup-restore.component.ts?vue&type=script&lang=ts&external"
export * from "./backup-restore.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports